import { reactive, ref } from 'vue'
import { useChangeRequester } from '../shared/use-change-requester'
import { persistentSettings } from '../shared/local-storage'

export const editorToolbarsHeightRem = 5.7917 // the height of the toolbar (LayoutToolbars)
export const floatingPanelsOffsetPx = 10
export const editorPanelTitleHeightRem = 4.6
export const defaultResolutionCap = 3
const defaultFpsCap = 60
const defaultBloom = true
const defaultVideoCodec = 'avc'
const defaultVideoWidth = 3840 // 4K
const defaultVideoHeight = 2160 // 4K
const defaultVideoFps = 60
const defaultVideoQuality = 1

export const initialEditorMode = ref()
export const initialEditorSimulation = ref()
export const editor = ref()
export const editorButtons = ref()
export const [editorMode, requestedEditorMode, editorModeChanging, resetEditorMode] = useChangeRequester()
export const [editorStatus, requestedEditorStatus, editorStatusChanging, resetEditorStatus] = useChangeRequester()
export const [editorViewType, requestedEditorViewType, editorViewTypeChanging, resetEditorViewType] =
  useChangeRequester('2d')
export const editorSimulations = ref()
export const [editorSimulation, requestedEditorSimulation, editorSimulationChanging, resetEditorSimulation] =
  useChangeRequester(null)
export const editorSelected = ref({})
export const editorLayoutData = ref({})
// The geometries the layout's track circuits are drawn in, as a printed sheet's legend names them.
export const editorDetectorGeometries = ref([])
// Whether the layout has a keyswitch, for a printed sheet's legend to name one only then.
export const editorKeyswitchesInUse = ref(false)
export const editorIdle = ref()
// Interaction with elements turned on: by its own button in a scene, by the engineer's view elsewhere.
export const editorControlMode = ref(false)
export const tramDashboard = ref()
export const simulationRunData = ref()
export const simulationOriginalTotalTime = ref(0)
export const manualControlZones = ref({})
// The gate the manual control panel has been narrowed to, set by clicking its signal in the scene. Nothing
// while the panel shows the whole layout, which is how it opens.
export const manualControlFocusGate = ref(null)
export const editorSaving = ref()
export const editorMetersPerPixel = ref()
export const editorCameraMode = ref()
export const editorInPlaceEdit = ref(null)
export const graphicSettings = reactive({
  resolutionCap: persistentSettings.value.resolutionCap ?? defaultResolutionCap,
  fpsCap: persistentSettings.value.fpsCap ?? defaultFpsCap,
  bloom: persistentSettings.value.bloom ?? defaultBloom,
  videoCodec: persistentSettings.value.videoCodec ?? defaultVideoCodec,
  videoWidth: persistentSettings.value.videoWidth ?? defaultVideoWidth,
  videoHeight: persistentSettings.value.videoHeight ?? defaultVideoHeight,
  videoFps: persistentSettings.value.videoFps ?? defaultVideoFps,
  videoQuality: persistentSettings.value.videoQuality ?? defaultVideoQuality
})
export const currentResolution = ref()
export const simulationResults = ref()
export const editorControlRights = ref([])
export const hideEditor = ref()
export const fpsHistory = ref([])
